module.exports = __webpack_public_path__ + "assets/a31dd0e8e450a671931d1b6efa53cd15.mp3";